<section class="product-program-benefits" [attr.aria-labelledby]="resolvedHeadingId">
  <div class="product-program-benefits__content">
    <header class="product-program-benefits__intro">
      <h2 class="product-program-benefits__title" [id]="resolvedHeadingId">{{ headline }}</h2>
      <p class="product-program-benefits__description">
        {{ description }}<ng-container *ngIf="descriptionLink">&ngsp;<a
          [routerLink]="descriptionLink.routerLink"
          class="product-program-benefits__description-link"
        >{{ descriptionLink.text }}</a></ng-container>
      </p>
    </header>

    <dl *ngIf="hasStats" class="product-program-benefits__stats">
      <div
        *ngFor="let stat of stats; trackBy: trackByStatIndex"
        class="product-program-benefits__stat"
      >
        <dt class="product-program-benefits__stat-label">{{ stat.label }}</dt>
        <dd class="product-program-benefits__stat-value">{{ stat.value }}</dd>
      </div>
    </dl>

    <ul *ngIf="hasCards" class="product-program-benefits__cards">
      <li
        *ngFor="let card of cards; trackBy: trackByCardIndex"
        #cardItem
        class="product-program-benefits__card-item"
      >
        <c11n-card
          class="product-program-benefits__card"
          density="small"
        >
          <div cardBody class="product-program-benefits__card-body">
            <img
              class="product-program-benefits__card-icon"
              [src]="card.iconSrc"
              alt=""
              aria-hidden="true"
            />
            <div class="product-program-benefits__card-text">
              <h3 class="product-program-benefits__card-title">{{ card.title }}</h3>
              <p class="product-program-benefits__card-description">{{ card.description }}</p>
            </div>
          </div>
        </c11n-card>
      </li>
    </ul>
  </div>
</section>
